import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { get } from '../../../server/actions'
import logo from '../../../assets/img/mealManageLogo.PNG'
import PropTypes from 'prop-types'
import { getLoginDistrictInfo } from '../../../server/utilDistrict';

class districtHeader extends Component {
    onLogoutClick = () => {
        console.log('this', this.context.router.history)
        let request = new Promise((resolve) => (get('/logout?access_token=').then(response => {
            console.log('resp', response);
            if (!response.ok || response.ok) {
                resolve(sessionStorage.clear());
            }
        })));

        Promise.resolve(request).then(() => {
            console.log('this', this.context.router.history);
            //this.context.router.history.push({pathname: '/login'});
            window.location.replace('/login');// redirect to login
        });
    };

    render() {
        const loginInfo = getLoginDistrictInfo()

        return (
            <header id="pageTop" className="header-wrapper">

                <div className="container-fluid color-bar top-fixed clearfix">
                    <div className="row">
                        <div className="col-sm-1 col-xs-2 bg-color-1">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-2">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-3">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-4">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-5">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-6">fix bar</div>
                        <div className="col-sm-1 bg-color-1 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-2 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-3 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-4 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-5 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-6 hidden-xs">fix bar</div>
                    </div>
                </div>
                <nav id="menuBar" className="navbar navbar-default lightHeader">
                    <div className="container">
                        <div className="navbar-header">
                            <button type="button" className="navbar-toggle" data-toggle="collapse"
                                data-target="#navbar">
                                <span className="icon-bar" />
                                <span className="icon-bar" />
                                <span className="icon-bar" />
                            </button>
                            <Link className="navbar-brand school-admin-brand" id="brand" to="/district"><img
                                className="admin-logo" src={loginInfo.schoolLogo ? loginInfo.schoolLogo : logo}
                                alt="" />
                                <div className="school-name">
                                    <span>{(loginInfo.schoolName || '')}</span>
                                </div>
                            </Link>

                            {/*  <Link className="navbar-brand" id="brand" to="/district"><img className="super-admin-logo"
                                                                                            src={logo} alt=""/></Link>
                            {
                                (loginInfo.schoolName||'').length>0 ?
                                <Link className="navbar-brand" id="brand" to="/district" style={{width:'auto', height:'70px'}}>
                                    <h3 style={{paddingTop:'4px', color:'#f47e35'}}>{(loginInfo.schoolName||'')}</h3>
                                </Link>
                                :
                                <Link className="navbar-brand" id="brand" to="/district"><img className="super-admin-logo"
                                                                                            src={logo} alt=""/></Link>

                            }  */}
                        </div>
                        <div className="navbar-collapse collapse" id="navbar">
                            <ul className="nav navbar-nav navbar-right" style={{ height: 'auto' }}>
                                <li className=" dropdown color-1 active ">
                                    <Link to="/district" role="button" aria-haspopup="true" aria-expanded="false"><i
                                        className="fa fa-home bg-color-1" aria-hidden="true" /> <span>Home</span></Link>
                                </li>
                                <li className=" dropdown megaDropMenu color-2 ">
                                    <a href="javascript:void(0)" className="dropdown-toggle" data-toggle="dropdown"
                                        data-hover="dropdown" aria-haspopup="true" data-delay="300"
                                        data-close-others="true" aria-expanded="false">
                                        <i className="fa fa-server bg-color-2" aria-hidden="true"></i>
                                        <span>Manage</span>
                                    </a>
                                    <ul className="row dropdown-menu">
                                        <li className="col-sm-3 col-xs-6">
                                            <ul className="list-unstyled">
                                                <li>District</li>
                                                <li className=""><Link to="/district">Summary</Link></li>
                                                <li className=""><Link to="/district/studentLookUp">Student Lookup</Link></li>
                                            </ul>
                                        </li>
                                        <li className="col-sm-3 col-xs-6">
                                            <ul className="list-unstyled">
                                                <li>Eligibility Management</li>
                                                <li className=""><Link to="/district/importCertificationData">Direct Certification Import</Link></li>
                                                <li className=""><Link to="/district/applicationDetails">Applications</Link></li>
                                                <li className=""><Link to="/district/applicationVerification">Application Verification</Link></li>
                                                <li><Link to="/district/eseaFormList">ESEA Form</Link></li>
                                            </ul>
                                        </li>
                                        <li className="col-sm-3 col-xs-6">
                                            <ul className="list-unstyled">
                                                <li>District Reports</li>
                                                <li className=""><Link to="/district/reports">Reports</Link> </li>
                                                <li className=""><Link to="/district/VerificationReport">Application Verification Report</Link> </li>
                                            </ul>
                                        </li>
                                        <li className="col-sm-3 col-xs-6">
                                            <ul className="list-unstyled">
                                                <li>User Management</li>
                                                <li className=""><Link to="/district/users">Users</Link></li>
                                            </ul>
                                        </li>
                                    </ul>

                                </li>
                                <li className=" dropdown singleDrop color-4">
                                    <a href="javascript:void(0)" className="dropdown-toggle" data-toggle="dropdown"
                                        role="button" aria-haspopup="true" aria-expanded="false"><i
                                            className="fa fa-sliders bg-color-6" aria-hidden="true" /> Settings</a>
                                    <ul className="dropdown-menu dropdown-menu-right">
                                        <li><Link to="/district/applicationSetting"><i className="fa fa-file-text"></i> Application Setting</Link></li>
                                        <li><Link to="/district/districtDirectCertificationSettings" ><i className="fa fa-database" aria-hidden="true" />&nbsp; Direct Certification Settings</Link></li>
                                        <li><Link to="/district/districteligibilityCodeSettings">
                                            <i className="fa fa-database"></i> Eligibility Code Settings</Link></li>
                                        <li>
                                            <Link to="/district/settings">
                                                <i className="fa fa-cog"></i> Settings
                                            </Link>
                                        </li>
                                    </ul>
                                </li>

                                <li className=" dropdown singleDrop color-4">
                                    <a href="javascript:void(0)" className="dropdown-toggle" data-toggle="dropdown"
                                        role="button" aria-haspopup="true" aria-expanded="false"><i
                                            className="fa fa-user bg-color-4" aria-hidden="true" /> <span>Account</span></a>
                                    <ul className="dropdown-menu dropdown-menu-right">
                                        {/* <li><Link to="/superAdmin/accountDetails"> <i
                                            className="fa fa-info-circle"/> Account
                                            details
                                        </Link></li> */}
                                        <li onClick={this.onLogoutClick.bind(this)}><Link to="/login"> <i
                                            className="fa fa-power-off" /> Logout </Link></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </header>

        )
    }
}

districtHeader.contextTypes = {
    router: PropTypes.object.isRequired
}

export default districtHeader;



// WEBPACK FOOTER //
// ./src/components/District/Home/districtHeader.jsx